import React from 'react';
import './MenuButton.css';

interface MenuButtonProps {
  onClick: () => void;
  isOpen: boolean;
}

const MenuButton: React.FC<MenuButtonProps> = ({ onClick, isOpen }) => {
  return (
    <button 
      className={`menu-button ${isOpen ? 'open' : ''}`}
      onClick={onClick}
      aria-label="Open navigation menu"
      aria-expanded={isOpen}
    >
      <span className="menu-line"></span>
      <span className="menu-line"></span>
      <span className="menu-line"></span>
    </button>
  );
};

export default MenuButton;

